import { Grid, Skeleton } from '@mui/material';

export const ListingCardGridSkeleton = () => (
  <Grid
    container
    columns={2}
    sx={{ rowGap: 2 }}
    data-testid="side-listings-grid-loading"
  >
    {[...new Array(4).keys()].map((i) => (
      <Grid size={1} key={i}>
        <Skeleton
          variant="rounded"
          sx={{
            height: '92px',
            width: '90%',
          }}
        />
      </Grid>
    ))}
  </Grid>
);
